<script setup>
import {computed, onMounted, ref} from 'vue';
import Button from '@/components/forms/Button.vue';
import {useRouter} from 'vue-router';
import {createConfirmDialog} from 'vuejs-confirm-dialog';
import CreateUpdateIntermediaryPersonModal from '@/components/modals/CreateUpdateIntermediaryPersonModal.vue';
import IntermediariesPeopleListComponent from '@/components/intermediaries-people/IntermediariesPeopleListComponent.vue';
import {getLoggedUser} from '@/services/AuthService';
import {useI18n} from 'vue-i18n';

const {t} = useI18n();
const router = useRouter();

// IMA-510: stránku sdílí INTERMEDIARY_LEADER (vidí a spravuje jen svůj podstrom poradců) i
// INTERMEDIARY_MANAGER (vidí celé vlastní SFA) - entityId je vlastní SFA, backend seznam dál
// omezí podle role (viz IntermediaryPersonController::visiblePersonIds()), tady se liší jen titulek.
const intermediaryId = ref(null);
const isLoading = ref(true);
const loggedUserRole = ref(null);
const pageTitle = computed(() => loggedUserRole.value === 'INTERMEDIARY_MANAGER' ? t('myAdvisorsIndex.title_manager') : t('myAdvisorsIndex.title'));

onMounted(() => {
  getLoggedUser().then(response => {
    intermediaryId.value = response.intermediary?.id ?? null;
    loggedUserRole.value = response.role;
    isLoading.value = false;
  });
});

function createUpdateIntermediaryPerson(intermediaryPerson = null) {
  const {reveal, onConfirm, onCancel} = createConfirmDialog(CreateUpdateIntermediaryPersonModal, intermediaryPerson ? {
    intermediaryPerson: intermediaryPerson,
    intermediary: {id: intermediaryId.value},
  } : {intermediary: {id: intermediaryId.value}});
  reveal();
  onConfirm((person) => {
    emitter.emit('intermediaryPersonSaved', person);
  });
  onCancel(() => {
  });
}
</script>

<template>
  <div class="page-section">
    <div class="page-section__heading">
      <div class="row">
        <div class="col-4">
          <a @click="router.back()" class="page-section__heading__back"><i class="mdi mdi-arrow-left"></i> {{ t('myAdvisorsIndex.back') }}</a>
        </div>
        <div class="col-4 text-center">
          <div class="page-section__title">{{ pageTitle }}</div>
        </div>
        <div class="col-4"></div>
      </div>
    </div>

    <div class="page-section__content">
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col">
              <div class="card-header__title">{{ pageTitle }}</div>
            </div>
            <div class="col text-end">
              <div class="card-header__action">
                <Button v-if="intermediaryId" :label="t('myAdvisorsIndex.add')" @click="createUpdateIntermediaryPerson()"/>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body">
          <IntermediariesPeopleListComponent v-if="!isLoading && intermediaryId" :entityId="intermediaryId"/>
        </div>
      </div>
    </div>
  </div>
</template>
